import { EnvType } from '@/Module/Core/Model/Enum';

const ENV = (process.env.NEXT_PUBLIC_BUILD_ENV as EnvType) || EnvType.DEVELOP;

export default ENV;
